import { render } from "./clienttaskstab.vue?vue&type=template&id=5a46cb62"
import script from "./clienttaskstab.vue?vue&type=script&lang=js"
export * from "./clienttaskstab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__